var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var Image_1 = __importDefault(require("./Image"));
exports.Image = Image_1.default;
exports.default = Image_1.default;
//# sourceMappingURL=index.js.map